import { Directive, effect, inject, input } from "@angular/core";
import { L10n, L10nBase } from "@skylab-angular-shared/core";
import { TooltipDirective } from "@skylab-angular-shared/ui";
import { CopyToClipboardService } from "./copy-to-clipboard.service";

@Directive({
    selector: '[sklCopyToClipboard]',
    host: {
        '(click)': 'onClick()'
    },
    hostDirectives: [{
        directive: TooltipDirective
    }]
})
export class CopyToClipboardDirective {
    value = input.required<string>({ alias: 'sklCopyToClipboard' });
    tooltipDirective: TooltipDirective = inject(TooltipDirective, { self: true });
    addValueToCopyTooltip = input<boolean>();

    #l10n = inject(L10n) as L10nBase;
    #copyToClipboardService = inject(CopyToClipboardService);

    constructor() {
        effect(() => {
            const tooltip = this.#l10n._T('scenes.shared.copy-to-clipboard.tooltip');
            this.tooltipDirective.setTooltip(this.addValueToCopyTooltip() ? `${tooltip}: ${this.value()}` : tooltip);
        });
    }

    onClick(): void {
        this.#copyToClipboardService.copy(this.value());
    }
}
